export const CLIENT_ID = 'web';
